import React from "react";
import { useLocation } from "react-router-dom";

// Scrolls window to top on every route change
export default function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
